import { motion } from "framer-motion";

/* Refined score bar — h-1 track, sharp fill, deep green (brass in dark mode). */
export const ScoreBar = ({ label, score, delay = 0 }) => (
    <div data-testid={`score-bar-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
        <div className="flex items-baseline justify-between">
            <span className="text-sm text-ink">{label}</span>
            <span className="text-sm tabular-nums text-ink-muted">
                {score} / 10
            </span>
        </div>
        <div className="mt-2.5 h-1 w-full bg-surface-muted">
            <motion.div
                className="h-full bg-pine dark:bg-brass"
                initial={{ width: 0 }}
                whileInView={{ width: `${score * 10}%` }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
            />
        </div>
    </div>
);
